// extracted by mini-css-extract-plugin
var _1 = "MultipleDynamic_multipleDynamicContainer__nSWDM";
export { _1 as "multipleDynamicContainer" }
